import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import s from './s.module.less';
import { isLocalhost, isOpPortal } from 'utils/common';
import useLoadBasicData from 'hooks/useLoadBasicData';

const { Content } = Layout;

const LayoutPage: React.FC = () => {
    const [loadBasicData] = useLoadBasicData();
    useEffect(() => {
        loadBasicData();
    }, [loadBasicData]);
    if (!isOpPortal() && !isLocalhost()) {
        return null;
    }

    return (
        <Layout className={s.layout}>
            <Layout className={s.siteLayout}>
                <Content>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default LayoutPage;
